import * as React from "react";
import { Select } from "antd";
import {
  defaultSelectFilterOption,
  defaultSelectFilterSort,
} from "../../../util/utils";
import { BUSINESS_TYPE } from "../../../util/constants";

const { Option } = Select;

interface BusinessTypeDropdownProps {
  defaultValue: string;
  tabIndex?: number;
  onChange: (value: string) => void;
}

export default function BusinessTypeDropdown({
  defaultValue,
  tabIndex,
  onChange,
}: BusinessTypeDropdownProps) {
  return (
    <Select
      defaultValue={defaultValue}
      tabIndex={tabIndex}
      size={"large"}
      onChange={onChange}
      className={"state-dropdown"}
      key={defaultValue}
      showSearch
      optionFilterProp="children"
      filterOption={defaultSelectFilterOption}
      filterSort={defaultSelectFilterSort}
    >
      <Option value={""} disabled={true}>
        Business Type
      </Option>
      {BUSINESS_TYPE.map((it) => (
        <Option key={it} value={it}>
          {it}
        </Option>
      ))}
    </Select>
  );
}
